import { GetterTree } from 'vuex';
import { State, MainContainerColor } from '@/core/store/general/state';
import { DelegationInterface } from '@/shared/interfaces/delegation.interface';

export interface Getters {
  isOpenNavbar: string;
  scrollTop: number;
  getDelegationList: DelegationInterface[];
  getDelegation: any;
  getServerError: string;
  hasServerError: boolean;
}

export const getters: GetterTree<State, any> = {
  isOpenNavbar: (state) => state.openNavbar,
  scrollTop: (state) => state.scrollTop,
  getDelegationList: (state) => state.delegationList,
  getLocationList: (state) => state.locationList,
  getDelegationListAcceptance: (state) => {
    return state.delegationList.filter(
      (delegation: any) => !delegation.budgetAceptationHide,
    );
  },
  getDelegation(state: State) {
    return (id: string) => {
      return state.delegationList.find((delegation: any) => {
        return delegation.id === id;
      });
    };
  },
  getServerError: (state) => state.serverError,
  hasServerError: (state) => state.serverError !== '',
  getClientMainContainerColor: (state) => state.clientMainContainerColor,
  isClientMainContainerColorWhite: (state) => {
    return state.clientMainContainerColor === MainContainerColor.White;
  },
  isClientMainContainerColorGreyLight: (state) => {
    return state.clientMainContainerColor === MainContainerColor.GreyLight;
  },
  isClientMainContainerColorGreyCustom: (state) => {
    return state.clientMainContainerColor === MainContainerColor.GreyCustom;
  },
};
